import { datetimeFormatter } from '../../../../utils/formatHelper';

const amountColumn = {
  text: 'Amount',
  dataField: 'amount',
};

const warehouseColumn = {
  text: 'Warehouse',
  dataField: 'warehouse_name',
};

const updatedColumn = {
  text: 'Updated',
  dataField: 'created_at',
  formatter: datetimeFormatter,
};

const InventoryInitiatorTypes = {
  USER: 'user',
  WAREHOUSE: 'warehouse',
  ORDER: 'order',
};

const inventoryInitiatorDisplayText = {
  [InventoryInitiatorTypes.USER]: 'Manual Update',
  [InventoryInitiatorTypes.WAREHOUSE]: 'Warehouse Update',
  [InventoryInitiatorTypes.ORDER]: 'Retailer Order (RETAILER_NAME)',
};

const displayInitiator = (initiator) => {
  const UNKNOWN = 'Unknown';

  if (!initiator) return UNKNOWN;

  if (initiator.type === InventoryInitiatorTypes.ORDER) {
    return inventoryInitiatorDisplayText[initiator.type].replace('RETAILER_NAME', initiator.retailerName);
  }
  if (initiator.type === InventoryInitiatorTypes.USER) {
    return initiator.userDisplayName;
  }
  return inventoryInitiatorDisplayText[initiator.type] || UNKNOWN;
};

const initiatorColumn = {
  text: 'Source',
  dataField: 'initiator',
  formatter: displayInitiator,
};

export const inventoryHistoryColumns = [amountColumn, warehouseColumn, initiatorColumn, updatedColumn];
export const inventoryHistoryColumnsWithoutInitiator = [amountColumn, warehouseColumn, updatedColumn];
